export const getSchemaOrgArticle = ({ authorName, defaultAuthor, seo }) => ({
  '@context': 'http://schema.org',
  '@type': 'Article',
  author: {
    '@type': 'Person',
    name: authorName ?? defaultAuthor,
  },
  copyrightHolder: {
    '@type': 'Person',
    name: defaultAuthor,
  },
  copyrightYear: '2021',
  creator: {
    '@type': 'Person',
    name: defaultAuthor,
  },
  publisher: {
    '@type': 'Organization',
    name: defaultAuthor,
    logo: {
      '@type': 'ImageObject',
      url: seo.image,
    },
  },
  datePublished: seo.firstPublicationDate,
  dateModified: seo.lastPublicationDate,
  description: seo.description,
  headline: seo.title,
  inLanguage: seo.lang,
  url: seo.url,
  name: seo.title,
  image: {
    '@type': 'ImageObject',
    url: seo.image,
  },
  mainEntityOfPage: seo.defaultUrl,
});
